(function () {
    var typed = '';
    var TRIGGER = 'shrike';

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; spawnShrike(); }
    });

    var path = decodeURIComponent(window.location.pathname);
    if (path.includes('/bücher/hyperion') || path.includes('/bücher/der-fall-von-hyperion')) {
        setTimeout(spawnShrike, 700);
    }

    function spawnShrike() {
        if (document.querySelector('.shrike-overlay')) return;

        var overlay = document.createElement('div');
        overlay.className = 'shrike-overlay';

        var figure = document.createElement('div');
        figure.className = 'shrike-figure';
        var c = '#1a0f0f'; var c2 = '#261616'; var r1 = '#bb0606'; var r2 = '#ff2828';
        figure.innerHTML = '<svg viewBox="0 0 360 520" width="265" height="383" overflow="visible" xmlns="http://www.w3.org/2000/svg">'
            // ── CROWN SPIKES (5) ───────────────────────────────
            + '<polygon points="120,54 108,14 145,48" fill="' + c + '"/>'
            + '<polygon points="150,36 145,6  170,32" fill="' + c + '"/>'
            + '<polygon points="180,28 180,2  190,28" fill="' + c + '"/>'
            + '<polygon points="210,36 215,6  190,32" fill="' + c + '"/>'
            + '<polygon points="240,54 252,14 215,48" fill="' + c + '"/>'
            // ── HEAD ──────────────────────────────────────────
            + '<ellipse cx="180" cy="102" rx="62" ry="68" fill="' + c + '"/>'
            // ── EYES ──────────────────────────────────────────
            + '<ellipse cx="153" cy="95" rx="15" ry="12" fill="' + r1 + '"/>'
            + '<ellipse cx="207" cy="95" rx="15" ry="12" fill="' + r1 + '"/>'
            + '<ellipse cx="153" cy="95" rx="6"  ry="5"  fill="' + r2 + '"/>'
            + '<ellipse cx="207" cy="95" rx="6"  ry="5"  fill="' + r2 + '"/>'
            // ── NECK ──────────────────────────────────────────
            + '<rect x="166" y="166" width="28" height="24" rx="3" fill="' + c + '"/>'
            // ── TORSO (wide, armored) ──────────────────────────
            + '<path d="M 116,188 Q 96,224 98,378 L 262,378 Q 264,224 244,188 Q 216,174 180,172 Q 144,174 116,188Z" fill="' + c + '"/>'
            + '<line x1="180" y1="172" x2="180" y2="378" stroke="rgba(80,22,16,0.4)" stroke-width="1.5"/>'
            + '<path d="M 130,224 Q 180,216 230,224" fill="none" stroke="rgba(88,28,18,0.55)" stroke-width="2"/>'
            + '<path d="M 124,264 Q 180,256 236,264" fill="none" stroke="rgba(88,28,18,0.55)" stroke-width="2"/>'
            + '<path d="M 120,304 Q 180,296 240,304" fill="none" stroke="rgba(88,28,18,0.55)" stroke-width="2"/>'
            + '<path d="M 118,344 Q 180,336 242,344" fill="none" stroke="rgba(88,28,18,0.55)" stroke-width="2"/>'
            // Torso side blades
            + '<polygon points="106,210 88,196 114,224" fill="' + c2 + '"/>'
            + '<polygon points="104,250 86,236 112,264" fill="' + c2 + '"/>'
            + '<polygon points="102,290 84,276 110,304" fill="' + c2 + '"/>'
            + '<polygon points="254,210 272,196 246,224" fill="' + c2 + '"/>'
            + '<polygon points="256,250 274,236 248,264" fill="' + c2 + '"/>'
            + '<polygon points="258,290 276,276 250,304" fill="' + c2 + '"/>'
            // ── SHOULDER SPIKES ────────────────────────────────
            + '<polygon points="116,190 96,172 128,200" fill="' + c + '"/>'
            + '<polygon points="244,190 264,172 232,200" fill="' + c + '"/>'
            // ── UPPER ARMS (blade shapes) ──────────────────────
            + '<path d="M 118,198 L 8,192 L -6,207 L 8,222 L 118,217 Z" fill="' + c + '"/>'
            + '<path d="M 242,198 L 352,192 L 366,207 L 352,222 L 242,217 Z" fill="' + c + '"/>'
            // ── LOWER ARMS (diagonal blades) ───────────────────
            + '<path d="M 126,276 L 40,382 L 20,414 L 56,398 L 30,426 L 70,406 L 162,304 Z" fill="' + c + '"/>'
            + '<path d="M 234,276 L 320,382 L 340,414 L 304,398 L 330,426 L 290,406 L 198,304 Z" fill="' + c + '"/>'
            // ── LEGS ──────────────────────────────────────────
            + '<rect x="148" y="376" width="24" height="132" rx="5" fill="' + c + '"/>'
            + '<rect x="188" y="376" width="24" height="132" rx="5" fill="' + c + '"/>'
            + '<polygon points="148,508 136,530 166,508" fill="' + c2 + '"/>'
            + '<polygon points="212,508 224,530 194,508" fill="' + c2 + '"/>'
            + '</svg>';

        var quote = document.createElement('div');
        quote.className = 'shrike-quote';
        quote.textContent = '„Es gibt keinen Gott des Schmerzes. Nur den Shrike."';

        var attr = document.createElement('div');
        attr.className = 'shrike-attr';
        attr.textContent = '— Hyperion, Dan Simmons';

        overlay.appendChild(figure);
        overlay.appendChild(quote);
        overlay.appendChild(attr);

        var closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', function () {
            overlay.classList.add('shrike-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        });
        overlay.appendChild(closeBtn);
        document.body.appendChild(overlay);

        setTimeout(function () {
            overlay.classList.add('shrike-overlay--fade');
            setTimeout(function () { overlay.remove(); }, 1200);
        }, 5000);
    }
})();
